import React from 'react';
import { motion } from 'framer-motion';
import { Building2, Wrench, Zap, CheckCircle2 } from 'lucide-react';
export function ServicesSection() {
  const services = [{
    title: 'Infraestructura y Obras Civiles',
    icon: <Building2 className="text-jml-blue" size={32} data-id="element-130" />,
    items: ['Obras civiles: fundaciones, losas y estructuras', 'Reparación de techumbres y pavimentos', 'Pintura industrial y alto tráfico', 'Tabiquería y carpintería']
  }, {
    title: 'Fabricación y Montaje',
    icon: <Wrench className="text-jml-orange" size={32} data-id="element-131" />,
    items: ['Estructuras metálicas', 'Soldadura y fabricación', 'Montaje industrial', 'Adecuaciones de infraestructura']
  }, {
    title: 'Mantenimiento Industrial',
    icon: <Zap className="text-yellow-500" size={32} data-id="element-132" />,
    items: ['Instalaciones eléctricas y tableros', 'Canalización y cableado', 'Certificaciones SEC y termografía', 'Sistemas hidráulicos (HDPE, PPR, PVC)']
  }];
  return <section id="servicios" className="py-24 bg-navy relative" data-id="element-133">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-134">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-135">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-136">
            <h2 className="text-sm font-bold tracking-widest text-jml-blue uppercase mb-3" data-id="element-137">
              Nuestras Soluciones
            </h2>
            <h3 className="text-4xl md:text-5xl font-bold text-white mb-6 font-heading" data-id="element-138">
              Nuestros servicios
            </h3>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-139">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-navy-light border border-white/10 rounded-2xl p-8 hover:border-white/20 transition-colors" data-id="element-140">
              <div className="bg-navy p-4 rounded-xl inline-block mb-6" data-id="element-141">
                {service.icon}
              </div>
              <h4 className="text-2xl font-bold text-white mb-6 font-heading" data-id="element-142">
                {service.title}
              </h4>
              <ul className="space-y-4" data-id="element-143">
                {service.items.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-144">
                    <CheckCircle2 className="text-jml-orange shrink-0 mt-1" size={18} data-id="element-145" />
                    <span className="text-gray-300 leading-relaxed" data-id="element-146">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}